// Log call to a function.
export const logCall = (obj, fn, sideEffect) => (...args) => {
	sideEffect({ name: fn.name, args });

	return fn.apply(obj, args);
};

/**
 * Executues a side effect when an object's functions are run.
 * @param {Object} obj - The object with functions we want to spy.
 * @param {Function} sideEffect - The side effect we want to run (e.g. a console.log).
 */
function logCalls(obj, sideEffect) {
	// Loop through the keys to find function properties.
	Object.keys(obj).forEach((key) => {
		const property = obj[key];

		// Wrap functions on object with logCall.
		if (typeof property === "function") {
			obj[key] = logCall(obj, property, sideEffect); // eslint-disable-line
		}
	});
}

export default logCalls;



// WEBPACK FOOTER //
// ./src/shared/util/logCalls.js